var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowCounterClockwise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23438 7.78906H2.48438V4.03906",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14063 14.8594C6.10189 15.8214 7.32689 16.4768 8.66066 16.7425C9.99443 17.0082 11.3771 16.8724 12.6336 16.3522C13.8902 15.832 14.9642 14.9508 15.7199 13.8201C16.4756 12.6894 16.879 11.36 16.879 10C16.879 8.64002 16.4756 7.31058 15.7199 6.17987C14.9642 5.04917 13.8902 4.16798 12.6336 3.64779C11.3771 3.12761 9.99443 2.99179 8.66066 3.25752C7.32689 3.52324 6.10189 4.17858 5.14063 5.14063L2.48438 7.78907",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCounterClockwise);
export default __webpack_public_path__ + "static/media/arrow-counter-clockwise.07c193f4aaa8c1914d9c466b84654a47.svg";
export { ForwardRef as ReactComponent };